import Analytics from './Analytics'
import campaignAnalyticsOptions from './campaign-analytics'
import consultAnalyticsOptions from './consult-analytics'

document.addEventListener('turbolinks:load', () => {
  const analytics = [campaignAnalyticsOptions, consultAnalyticsOptions]

  analytics.forEach( (analytic) => {
    analytic = analytic()

    if (!analytic) return

    new Analytics(analytic.target, analytic.options).init()
  })
})
